const Icon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 333.9 117.83"
        {...props}
    >
        <defs>
            <style>
                {
                    '.cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#eaa30a;}.cls-4{fill:#eaa30d;}.cls-5{fill:#e9a210;}.cls-6{fill:#e9a213;}.cls-7{fill:#e8a116;}.cls-8{fill:#e8a118;}.cls-9{fill:#e7a01a;}.cls-10{fill:#e7a01c;}.cls-11{fill:#e6a01d;}.cls-12{fill:#e69f1f;}.cls-13{fill:#e69f21;}.cls-14{fill:#e59e22;}.cls-15{fill:#e59e24;}.cls-16{fill:#e49d25;}.cls-17{fill:#e49d27;}.cls-18{fill:#e39c28;}.cls-19{fill:#e39c29;}.cls-20{fill:#e29b2a;}.cls-21{fill:#e29b2c;}.cls-22{fill:#e19a2d;}.cls-23{fill:#e19a2e;}.cls-24{fill:#e1992f;}.cls-25{fill:#e09930;}.cls-26{fill:#e09931;}.cls-27{fill:#df9832;}.cls-28{fill:#df9833;}.cls-29{fill:#df9734;}.cls-30{fill:#de9735;}.cls-31{fill:#de9636;}.cls-32{fill:#dd9637;}.cls-33{fill:#dd9538;}.cls-34{fill:#dc9539;}.cls-35{fill:#dc953a;}.cls-36{fill:#dc943b;}.cls-37{fill:#db943c;}.cls-38{fill:#db933d;}.cls-39{fill:#da933e;}.cls-40{fill:#da923f;}.cls-41{fill:#d99240;}.cls-42{fill:#d99141;}.cls-43{fill:#d89142;}.cls-44{fill:#d89043;}.cls-45{fill:#d79044;}.cls-46{fill:#d78f45;}.cls-47{fill:#d68f46;}.cls-48{fill:#d68e47;}.cls-49{fill:#d58e47;}.cls-50{fill:#d58d48;}.cls-51{fill:#d48d49;}.cls-52{fill:#d48c4a;}.cls-53{fill:#d38c4b;}.cls-54{fill:#d38b4c;}.cls-55{fill:#d28b4d;}.cls-56{fill:#d28a4e;}.cls-57{fill:#d18a4e;}.cls-58{fill:#d1894f;}.cls-59{fill:#d08950;}.cls-60{fill:#d08851;}.cls-61{fill:#cf8851;}.cls-62{fill:#cf8752;}.cls-63{fill:#cf8753;}.cls-64{fill:#ce8753;}.cls-65{fill:#ce8654;}.cls-66{fill:#cd8655;}.cls-67{fill:#cd8555;}.cls-68{fill:#cc8556;}.cls-69{fill:#cc8457;}.cls-70{fill:#cb8358;}.cls-71{fill:#ca8359;}.cls-72{fill:#ca825a;}.cls-73{fill:#c9815b;}.cls-74{fill:#c8805c;}.cls-75{fill:#c8805d;}.cls-76{fill:#c7805d;}.cls-77{fill:#c77f5e;}.cls-78{fill:#c67e5f;}.cls-79{fill:#c67e60;}.cls-80{fill:#c57e60;}.cls-81{fill:#c57d61;}.cls-82{fill:#c47c62;}.cls-83{fill:#c37b63;}.cls-84{fill:#c27b64;}.cls-85{fill:#c27a64;}.cls-86{fill:#c17a65;}.cls-87{fill:#c17966;}.cls-88{fill:#c07867;}.cls-89{fill:#bf7868;}.cls-90{fill:#bf7768;}.cls-91{fill:#be7769;}.cls-92{fill:#be7669;}.cls-93{fill:#bd7669;}.cls-94{fill:#bd756a;}.cls-95{fill:#bc746b;}.cls-96{fill:#bb746c;}.cls-97{fill:#bb736c;}.cls-98{fill:#ba736d;}.cls-99{fill:#ba726d;}.cls-100{fill:#b9716e;}.cls-101{fill:#b8706f;}.cls-102{fill:#b7706f;}.cls-103{fill:#b76f70;}.cls-104{fill:#b66f70;}.cls-105{fill:#b66e71;}.cls-106{fill:#b56d71;}.cls-107{fill:#b56d72;}.cls-108{fill:#b46c72;}.cls-109{fill:#b36c73;}.cls-110{fill:#b36b73;}.cls-111{fill:#b36b74;}.cls-112{fill:#b26a74;}.cls-113{fill:#b16975;}.cls-114{fill:#b06875;}.cls-115{fill:#b06876;}.cls-116{fill:#b06776;}.cls-117{fill:#af6776;}.cls-118{fill:#af6677;}.cls-119{fill:#ae6677;}.cls-120{fill:#ad6578;}.cls-121{fill:#ad6478;}.cls-122{fill:#ac6479;}.cls-123{fill:#ac6379;}.cls-124{fill:#ab6379;}.cls-125{fill:#ab6279;}.cls-126{fill:#aa627a;}.cls-127{fill:#aa617a;}.cls-128{fill:#a9617b;}.cls-129{fill:#a9607b;}.cls-130{fill:#a8607b;}.cls-131{fill:#a85f7c;}.cls-132{fill:#a75e7c;}.cls-133{fill:#a65e7d;}.cls-134{fill:#a65d7d;}.cls-135{fill:#a55c7d;}.cls-136{fill:#a55c7e;}.cls-137{fill:#a45b7e;}.cls-138{fill:#a45a7e;}.cls-139{fill:#a35a7f;}.cls-140{fill:#a2597f;}.cls-141{fill:#a2587f;}.cls-142{fill:#a15880;}.cls-143{fill:#a15780;}.cls-144{fill:#a05780;}.cls-145{fill:#a05680;}.cls-146{fill:#a05681;}.cls-147{fill:#9f5681;}.cls-148{fill:#9f5581;}.cls-149{fill:#9e5581;}.cls-150{fill:#9e5481;}.cls-151{fill:#9e5482;}.cls-152{fill:#9d5382;}.cls-153{fill:#9c5282;}.cls-154{fill:#9b5183;}.cls-155{fill:#9b5083;}.cls-156{fill:#9a5083;}.cls-157{fill:#994f84;}.cls-158{fill:#994e84;}.cls-159{fill:#984e84;}.cls-160{fill:#984d84;}.cls-161{fill:#974d85;}.cls-162{fill:#974c85;}.cls-163{fill:#964b85;}.cls-164{fill:#954a85;}.cls-165{fill:#954986;}.cls-166{fill:#944986;}.cls-167{fill:#944886;}.cls-168{fill:#934886;}.cls-169{fill:#934786;}.cls-170{fill:#924786;}.cls-171{fill:#924687;}.cls-172{fill:#914587;}.cls-173{fill:#904487;}.cls-174{fill:#8f4388;}.cls-175{fill:#8e4288;}.cls-176{fill:#8e4188;}.cls-177{fill:#8d4188;}.cls-178{fill:#8d4088;}.cls-179{fill:#8c4089;}.cls-180{fill:#8b3f89;}.cls-181{fill:#8b3e89;}.cls-182{fill:#8a3e89;}.cls-183{fill:#8a3d89;}.cls-184{fill:#893d89;}.cls-185{fill:#893c8a;}.cls-186{fill:#883c8a;}.cls-187{fill:#883b8a;}.cls-188{fill:#873b8a;}.cls-189{fill:#873a8a;}.cls-190{fill:#863a8b;}.cls-191{fill:#86398b;}.cls-192{fill:#85398b;}.cls-193{fill:#85388b;}.cls-194{fill:#84388b;}.cls-195{fill:#84378b;}.cls-196{fill:#83378b;}.cls-197{fill:#83368b;}.cls-198{fill:#83368c;}.cls-199{fill:#82368c;}.cls-200{fill:#1d1d1b;}.cls-201{fill:#fff;}'
                }
            </style>
            <clipPath id="clip-path">
                <path
                    className="cls-1"
                    d="M333.84,18.07a17.78,17.78,0,0,0-18.21-18Q271.29,0,227,.05a17.82,17.82,0,0,0-18.12,18.12q-.1,30.35,0,60.69c0,10.45,7.94,18.23,18.46,18.32,3,0,5.93,0,9.34,0,0,4.75,0,9.19,0,13.63,0,2.7.59,5.14,3.28,6.42s4.94.35,7.14-1.29c7.7-5.74,15.47-11.4,23.14-17.17A7.47,7.47,0,0,1,275,97.15q20.24.1,40.48,0c10.3,0,18.3-7.8,18.34-17.93Q334,48.66,333.84,18.07Z"
                />
            </clipPath>
        </defs>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g className="cls-2">
                    <polygon className="cls-3" points="260.4 -0.02 208.77 43.97 208.77 -0.02 260.4 -0.02" />
                    <polygon
                        className="cls-3"
                        points="261.09 -0.02 208.77 44.56 208.77 43.97 260.4 -0.02 261.09 -0.02"
                    />
                    <polygon
                        className="cls-4"
                        points="261.79 -0.02 208.77 45.16 208.77 44.56 261.09 -0.02 261.79 -0.02"
                    />
                    <polygon
                        className="cls-5"
                        points="262.49 -0.02 208.77 45.75 208.77 45.16 261.79 -0.02 262.49 -0.02"
                    />
                    <polygon
                        className="cls-6"
                        points="263.18 -0.02 208.77 46.34 208.77 45.75 262.49 -0.02 263.18 -0.02"
                    />
                    <polygon
                        className="cls-7"
                        points="263.88 -0.02 208.77 46.94 208.77 46.34 263.18 -0.02 263.88 -0.02"
                    />
                    <polygon
                        className="cls-8"
                        points="264.57 -0.02 208.77 47.53 208.77 46.94 263.88 -0.02 264.57 -0.02"
                    />
                    <polygon
                        className="cls-9"
                        points="265.27 -0.02 208.77 48.12 208.77 47.53 264.57 -0.02 265.27 -0.02"
                    />
                    <polygon
                        className="cls-10"
                        points="265.97 -0.02 208.77 48.72 208.77 48.12 265.27 -0.02 265.97 -0.02"
                    />
                    <polygon
                        className="cls-11"
                        points="266.66 -0.02 208.77 49.31 208.77 48.72 265.97 -0.02 266.66 -0.02"
                    />
                    <polygon
                        className="cls-12"
                        points="267.36 -0.02 208.77 49.9 208.77 49.31 266.66 -0.02 267.36 -0.02"
                    />
                    <polygon
                        className="cls-13"
                        points="268.06 -0.02 208.77 50.49 208.77 49.9 267.36 -0.02 268.06 -0.02"
                    />
                    <polygon
                        className="cls-14"
                        points="268.75 -0.02 208.77 51.09 208.77 50.49 268.06 -0.02 268.75 -0.02"
                    />
                    <polygon
                        className="cls-15"
                        points="269.45 -0.02 208.77 51.68 208.77 51.09 268.75 -0.02 269.45 -0.02"
                    />
                    <polygon
                        className="cls-16"
                        points="270.14 -0.02 208.77 52.27 208.77 51.68 269.45 -0.02 270.14 -0.02"
                    />
                    <polygon
                        className="cls-17"
                        points="270.84 -0.02 208.77 52.87 208.77 52.27 270.14 -0.02 270.84 -0.02"
                    />
                    <polygon
                        className="cls-18"
                        points="271.54 -0.02 208.77 53.46 208.77 52.87 270.84 -0.02 271.54 -0.02"
                    />
                    <polygon
                        className="cls-19"
                        points="272.23 -0.02 208.77 54.05 208.77 53.46 271.54 -0.02 272.23 -0.02"
                    />
                    <polygon
                        className="cls-20"
                        points="272.93 -0.02 208.77 54.65 208.77 54.05 272.23 -0.02 272.93 -0.02"
                    />
                    <polygon
                        className="cls-21"
                        points="273.62 -0.02 208.77 55.24 208.77 54.65 272.93 -0.02 273.62 -0.02"
                    />
                    <polygon
                        className="cls-22"
                        points="274.32 -0.02 208.77 55.83 208.77 55.24 273.62 -0.02 274.32 -0.02"
                    />
                    <polygon
                        className="cls-23"
                        points="275.02 -0.02 208.77 56.42 208.77 55.83 274.32 -0.02 275.02 -0.02"
                    />
                    <polygon
                        className="cls-24"
                        points="275.71 -0.02 208.77 57.02 208.77 56.42 275.02 -0.02 275.71 -0.02"
                    />
                    <polygon
                        className="cls-25"
                        points="276.41 -0.02 208.77 57.61 208.77 57.02 275.71 -0.02 276.41 -0.02"
                    />
                    <polygon
                        className="cls-26"
                        points="277.1 -0.02 208.77 58.2 208.77 57.61 276.41 -0.02 277.1 -0.02"
                    />
                    <polygon className="cls-27" points="277.8 -0.02 208.77 58.8 208.77 58.2 277.1 -0.02 277.8 -0.02" />
                    <polygon className="cls-28" points="278.5 -0.02 208.77 59.39 208.77 58.8 277.8 -0.02 278.5 -0.02" />
                    <polygon
                        className="cls-29"
                        points="279.19 -0.02 208.77 59.98 208.77 59.39 278.5 -0.02 279.19 -0.02"
                    />
                    <polygon
                        className="cls-30"
                        points="279.89 -0.02 208.77 60.58 208.77 59.98 279.19 -0.02 279.89 -0.02"
                    />
                    <polygon
                        className="cls-31"
                        points="280.58 -0.02 208.77 61.17 208.77 60.58 279.89 -0.02 280.58 -0.02"
                    />
                    <polygon
                        className="cls-32"
                        points="281.28 -0.02 208.77 61.76 208.77 61.17 280.58 -0.02 281.28 -0.02"
                    />
                    <polygon
                        className="cls-33"
                        points="281.98 -0.02 208.77 62.35 208.77 61.76 281.28 -0.02 281.98 -0.02"
                    />
                    <polygon
                        className="cls-34"
                        points="282.67 -0.02 208.77 62.95 208.77 62.35 281.98 -0.02 282.67 -0.02"
                    />
                    <polygon
                        className="cls-35"
                        points="283.37 -0.02 208.77 63.54 208.77 62.95 282.67 -0.02 283.37 -0.02"
                    />
                    <polygon
                        className="cls-36"
                        points="284.06 -0.02 208.77 64.14 208.77 63.54 283.37 -0.02 284.06 -0.02"
                    />
                    <polygon
                        className="cls-37"
                        points="284.76 -0.02 208.77 64.73 208.77 64.14 284.06 -0.02 284.76 -0.02"
                    />
                    <polygon
                        className="cls-38"
                        points="285.46 -0.02 208.77 65.32 208.77 64.73 284.76 -0.02 285.46 -0.02"
                    />
                    <polygon
                        className="cls-39"
                        points="286.15 -0.02 208.77 65.91 208.77 65.32 285.46 -0.02 286.15 -0.02"
                    />
                    <polygon
                        className="cls-40"
                        points="286.85 -0.02 208.77 66.51 208.77 65.91 286.15 -0.02 286.85 -0.02"
                    />
                    <polygon
                        className="cls-41"
                        points="287.55 -0.02 208.77 67.1 208.77 66.51 286.85 -0.02 287.55 -0.02"
                    />
                    <polygon
                        className="cls-42"
                        points="288.24 -0.02 208.77 67.69 208.77 67.1 287.55 -0.02 288.24 -0.02"
                    />
                    <polygon
                        className="cls-43"
                        points="288.94 -0.02 208.77 68.29 208.77 67.69 288.24 -0.02 288.94 -0.02"
                    />
                    <polygon
                        className="cls-43"
                        points="289.63 -0.02 208.77 68.88 208.77 68.29 288.94 -0.02 289.63 -0.02"
                    />
                    <polygon
                        className="cls-44"
                        points="290.33 -0.02 208.77 69.47 208.77 68.88 289.63 -0.02 290.33 -0.02"
                    />
                    <polygon
                        className="cls-45"
                        points="291.02 -0.02 208.77 70.06 208.77 69.47 290.33 -0.02 291.02 -0.02"
                    />
                    <polygon
                        className="cls-46"
                        points="291.72 -0.02 208.77 70.66 208.77 70.06 291.02 -0.02 291.72 -0.02"
                    />
                    <polygon
                        className="cls-47"
                        points="292.42 -0.02 208.77 71.25 208.77 70.66 291.72 -0.02 292.42 -0.02"
                    />
                    <polygon
                        className="cls-48"
                        points="293.11 -0.02 208.77 71.84 208.77 71.25 292.42 -0.02 293.11 -0.02"
                    />
                    <polygon
                        className="cls-49"
                        points="293.81 -0.02 208.77 72.44 208.77 71.84 293.11 -0.02 293.81 -0.02"
                    />
                    <polygon
                        className="cls-50"
                        points="294.51 -0.02 208.77 73.03 208.77 72.44 293.81 -0.02 294.51 -0.02"
                    />
                    <polygon
                        className="cls-51"
                        points="295.2 -0.02 208.77 73.62 208.77 73.03 294.51 -0.02 295.2 -0.02"
                    />
                    <polygon
                        className="cls-52"
                        points="295.9 -0.02 208.77 74.22 208.77 73.62 295.2 -0.02 295.9 -0.02"
                    />
                    <polygon
                        className="cls-53"
                        points="296.59 -0.02 208.77 74.81 208.77 74.22 295.9 -0.02 296.59 -0.02"
                    />
                    <polygon
                        className="cls-53"
                        points="297.29 -0.02 208.77 75.4 208.77 74.81 296.59 -0.02 297.29 -0.02"
                    />
                    <polygon className="cls-54" points="297.99 -0.02 208.77 76 208.77 75.4 297.29 -0.02 297.99 -0.02" />
                    <polygon
                        className="cls-55"
                        points="298.68 -0.02 208.77 76.59 208.77 76 297.99 -0.02 298.68 -0.02"
                    />
                    <polygon
                        className="cls-56"
                        points="299.38 -0.02 208.77 77.18 208.77 76.59 298.68 -0.02 299.38 -0.02"
                    />
                    <polygon
                        className="cls-57"
                        points="300.07 -0.02 208.77 77.78 208.77 77.18 299.38 -0.02 300.07 -0.02"
                    />
                    <polygon
                        className="cls-58"
                        points="300.77 -0.02 208.77 78.37 208.77 77.78 300.07 -0.02 300.77 -0.02"
                    />
                    <polygon
                        className="cls-59"
                        points="301.47 -0.02 208.77 78.96 208.77 78.37 300.77 -0.02 301.47 -0.02"
                    />
                    <polygon
                        className="cls-60"
                        points="302.16 -0.02 208.77 79.56 208.77 78.96 301.47 -0.02 302.16 -0.02"
                    />
                    <polygon
                        className="cls-61"
                        points="302.86 -0.02 208.77 80.15 208.77 79.56 302.16 -0.02 302.86 -0.02"
                    />
                    <polygon
                        className="cls-62"
                        points="303.56 -0.02 208.77 80.74 208.77 80.15 302.86 -0.02 303.56 -0.02"
                    />
                    <polygon
                        className="cls-63"
                        points="304.25 -0.02 208.77 81.33 208.77 80.74 303.56 -0.02 304.25 -0.02"
                    />
                    <polygon
                        className="cls-64"
                        points="304.95 -0.02 208.77 81.93 208.77 81.33 304.25 -0.02 304.95 -0.02"
                    />
                    <polygon
                        className="cls-65"
                        points="305.64 -0.02 208.77 82.52 208.77 81.93 304.95 -0.02 305.64 -0.02"
                    />
                    <polygon
                        className="cls-66"
                        points="306.34 -0.02 208.77 83.11 208.77 82.52 305.64 -0.02 306.34 -0.02"
                    />
                    <polygon
                        className="cls-67"
                        points="307.04 -0.02 208.77 83.71 208.77 83.11 306.34 -0.02 307.04 -0.02"
                    />
                    <polygon
                        className="cls-68"
                        points="307.73 -0.02 208.77 84.3 208.77 83.71 307.04 -0.02 307.73 -0.02"
                    />
                    <polygon
                        className="cls-69"
                        points="308.43 -0.02 208.77 84.89 208.77 84.3 307.73 -0.02 308.43 -0.02"
                    />
                    <polygon
                        className="cls-69"
                        points="309.12 -0.02 208.77 85.48 208.77 84.89 308.43 -0.02 309.12 -0.02"
                    />
                    <polygon
                        className="cls-70"
                        points="309.82 -0.02 208.77 86.08 208.77 85.48 309.12 -0.02 309.82 -0.02"
                    />
                    <polygon
                        className="cls-70"
                        points="310.51 -0.02 208.77 86.67 208.77 86.08 309.82 -0.02 310.51 -0.02"
                    />
                    <polygon
                        className="cls-71"
                        points="311.21 -0.02 208.77 87.27 208.77 86.67 310.51 -0.02 311.21 -0.02"
                    />
                    <polygon
                        className="cls-72"
                        points="311.91 -0.02 208.77 87.86 208.77 87.27 311.21 -0.02 311.91 -0.02"
                    />
                    <polygon
                        className="cls-72"
                        points="312.6 -0.02 208.77 88.45 208.77 87.86 311.91 -0.02 312.6 -0.02"
                    />
                    <polygon
                        className="cls-73"
                        points="313.3 -0.02 208.77 89.04 208.77 88.45 312.6 -0.02 313.3 -0.02"
                    />
                    <polygon className="cls-73" points="314 -0.02 208.77 89.64 208.77 89.04 313.3 -0.02 314 -0.02" />
                    <polygon
                        className="cls-74"
                        points="314.69 -0.02 208.77 90.23 208.77 89.64 314 -0.02 314.69 -0.02"
                    />
                    <polygon
                        className="cls-75"
                        points="315.39 -0.02 208.77 90.82 208.77 90.23 314.69 -0.02 315.39 -0.02"
                    />
                    <polygon
                        className="cls-76"
                        points="316.08 -0.02 208.77 91.42 208.77 90.82 315.39 -0.02 316.08 -0.02"
                    />
                    <polygon
                        className="cls-77"
                        points="316.78 -0.02 208.77 92.01 208.77 91.42 316.08 -0.02 316.78 -0.02"
                    />
                    <polygon
                        className="cls-77"
                        points="317.48 -0.02 208.91 92.48 208.77 92.31 208.77 92.01 316.78 -0.02 317.48 -0.02"
                    />
                    <polygon
                        className="cls-78"
                        points="318.17 -0.02 209.2 92.82 208.91 92.48 317.48 -0.02 318.17 -0.02"
                    />
                    <polygon
                        className="cls-79"
                        points="318.87 -0.02 209.5 93.17 209.2 92.82 318.17 -0.02 318.87 -0.02"
                    />
                    <polygon
                        className="cls-80"
                        points="319.56 -0.02 209.79 93.51 209.5 93.17 318.87 -0.02 319.56 -0.02"
                    />
                    <polygon
                        className="cls-81"
                        points="320.26 -0.02 210.08 93.85 209.79 93.51 319.56 -0.02 320.26 -0.02"
                    />
                    <polygon
                        className="cls-81"
                        points="320.96 -0.02 210.38 94.2 210.08 93.85 320.26 -0.02 320.96 -0.02"
                    />
                    <polygon
                        className="cls-82"
                        points="321.65 -0.02 210.67 94.54 210.38 94.2 320.96 -0.02 321.65 -0.02"
                    />
                    <polygon
                        className="cls-82"
                        points="322.35 -0.02 210.96 94.88 210.67 94.54 321.65 -0.02 322.35 -0.02"
                    />
                    <polygon
                        className="cls-83"
                        points="323.05 -0.02 211.25 95.23 210.96 94.88 322.35 -0.02 323.05 -0.02"
                    />
                    <polygon
                        className="cls-83"
                        points="323.74 -0.02 211.55 95.57 211.25 95.23 323.05 -0.02 323.74 -0.02"
                    />
                    <polygon
                        className="cls-84"
                        points="324.44 -0.02 211.84 95.92 211.55 95.57 323.74 -0.02 324.44 -0.02"
                    />
                    <polygon
                        className="cls-85"
                        points="325.13 -0.02 212.13 96.26 211.84 95.92 324.44 -0.02 325.13 -0.02"
                    />
                    <polygon
                        className="cls-86"
                        points="325.83 -0.02 212.43 96.6 212.13 96.26 325.13 -0.02 325.83 -0.02"
                    />
                    <polygon
                        className="cls-87"
                        points="326.52 -0.02 212.72 96.95 212.43 96.6 325.83 -0.02 326.52 -0.02"
                    />
                    <polygon
                        className="cls-87"
                        points="327.22 -0.02 213.01 97.29 212.72 96.95 326.52 -0.02 327.22 -0.02"
                    />
                    <polygon
                        className="cls-88"
                        points="327.92 -0.02 213.3 97.63 213.01 97.29 327.22 -0.02 327.92 -0.02"
                    />
                    <polygon
                        className="cls-88"
                        points="328.61 -0.02 213.6 97.98 213.3 97.63 327.92 -0.02 328.61 -0.02"
                    />
                    <polygon
                        className="cls-89"
                        points="329.31 -0.02 213.89 98.32 213.6 97.98 328.61 -0.02 329.31 -0.02"
                    />
                    <polygon
                        className="cls-90"
                        points="329.74 -0.02 329.85 0.11 214.18 98.66 213.89 98.32 329.31 -0.02 329.74 -0.02"
                    />
                    <rect
                        className="cls-91"
                        x={196.18}
                        y={49.33}
                        width={151.96}
                        height={0.45}
                        transform="translate(32.86 188.35) rotate(-40.43)"
                    />
                    <rect
                        className="cls-92"
                        x={196.47}
                        y={49.68}
                        width={151.96}
                        height={0.45}
                        transform="translate(32.71 188.62) rotate(-40.43)"
                    />
                    <rect
                        className="cls-93"
                        x={196.77}
                        y={50.02}
                        width={151.96}
                        height={0.45}
                        transform="translate(32.55 188.89) rotate(-40.43)"
                    />
                    <rect
                        className="cls-94"
                        x={197.06}
                        y={50.36}
                        width={151.96}
                        height={0.45}
                        transform="translate(32.4 189.16) rotate(-40.43)"
                    />
                    <rect
                        className="cls-94"
                        x={197.35}
                        y={50.71}
                        width={151.96}
                        height={0.45}
                        transform="translate(32.25 189.43) rotate(-40.43)"
                    />
                    <rect
                        className="cls-95"
                        x={197.65}
                        y={51.05}
                        width={151.96}
                        height={0.45}
                        transform="translate(32.09 189.71) rotate(-40.43)"
                    />
                    <rect
                        className="cls-95"
                        x={197.94}
                        y={51.39}
                        width={151.96}
                        height={0.45}
                        transform="translate(31.94 189.98) rotate(-40.43)"
                    />
                    <rect
                        className="cls-96"
                        x={198.23}
                        y={51.74}
                        width={151.96}
                        height={0.45}
                        transform="translate(31.79 190.25) rotate(-40.43)"
                    />
                    <rect
                        className="cls-97"
                        x={198.52}
                        y={52.08}
                        width={151.96}
                        height={0.45}
                        transform="translate(31.63 190.52) rotate(-40.43)"
                    />
                    <rect
                        className="cls-98"
                        x={198.82}
                        y={52.43}
                        width={151.96}
                        height={0.45}
                        transform="translate(31.48 190.79) rotate(-40.43)"
                    />
                    <rect
                        className="cls-99"
                        x={199.11}
                        y={52.77}
                        width={151.96}
                        height={0.45}
                        transform="translate(31.33 191.06) rotate(-40.43)"
                    />
                    <rect
                        className="cls-99"
                        x={199.4}
                        y={53.11}
                        width={151.96}
                        height={0.45}
                        transform="translate(31.18 191.34) rotate(-40.43)"
                    />
                    <rect
                        className="cls-100"
                        x={199.69}
                        y={53.46}
                        width={151.96}
                        height={0.45}
                        transform="translate(31.02 191.61) rotate(-40.43)"
                    />
                    <polygon
                        className="cls-100"
                        points="333.66 4.58 333.93 4.89 333.93 4.94 218.28 103.47 217.99 103.13 333.66 4.58"
                    />
                    <polygon
                        className="cls-101"
                        points="333.93 5.53 218.57 103.82 218.28 103.47 333.93 4.94 333.93 5.53"
                    />
                    <polygon
                        className="cls-101"
                        points="333.93 6.13 218.87 104.16 218.57 103.82 333.93 5.53 333.93 6.13"
                    />
                    <polygon
                        className="cls-102"
                        points="333.93 6.72 219.16 104.51 218.87 104.16 333.93 6.13 333.93 6.72"
                    />
                    <polygon
                        className="cls-103"
                        points="333.93 7.31 219.45 104.85 219.16 104.51 333.93 6.72 333.93 7.31"
                    />
                    <polygon
                        className="cls-104"
                        points="333.93 7.91 219.74 105.19 219.45 104.85 333.93 7.31 333.93 7.91"
                    />
                    <polygon
                        className="cls-105"
                        points="333.93 8.5 220.04 105.54 219.74 105.19 333.93 7.91 333.93 8.5"
                    />
                    <polygon
                        className="cls-105"
                        points="333.93 9.09 220.33 105.88 220.04 105.54 333.93 8.5 333.93 9.09"
                    />
                    <polygon
                        className="cls-106"
                        points="333.93 9.69 220.62 106.22 220.33 105.88 333.93 9.09 333.93 9.69"
                    />
                    <polygon
                        className="cls-107"
                        points="333.93 10.28 220.91 106.57 220.62 106.22 333.93 9.69 333.93 10.28"
                    />
                    <polygon
                        className="cls-108"
                        points="333.93 10.87 221.21 106.91 220.91 106.57 333.93 10.28 333.93 10.87"
                    />
                    <polygon
                        className="cls-108"
                        points="333.93 11.46 221.5 107.25 221.21 106.91 333.93 10.87 333.93 11.46"
                    />
                    <polygon
                        className="cls-109"
                        points="333.93 12.06 221.79 107.6 221.5 107.25 333.93 11.46 333.93 12.06"
                    />
                    <polygon
                        className="cls-110"
                        points="333.93 12.65 222.09 107.94 221.79 107.6 333.93 12.06 333.93 12.65"
                    />
                    <polygon
                        className="cls-111"
                        points="333.93 13.24 222.38 108.29 222.09 107.94 333.93 12.65 333.93 13.24"
                    />
                    <polygon
                        className="cls-112"
                        points="333.93 13.84 222.67 108.63 222.38 108.29 333.93 13.24 333.93 13.84"
                    />
                    <polygon
                        className="cls-112"
                        points="333.93 14.43 222.96 108.97 222.67 108.63 333.93 13.84 333.93 14.43"
                    />
                    <polygon
                        className="cls-113"
                        points="333.93 15.02 223.26 109.32 222.96 108.97 333.93 14.43 333.93 15.02"
                    />
                    <polygon
                        className="cls-113"
                        points="333.93 15.62 223.55 109.66 223.26 109.32 333.93 15.02 333.93 15.62"
                    />
                    <polygon
                        className="cls-114"
                        points="333.93 16.21 223.84 110 223.55 109.66 333.93 15.62 333.93 16.21"
                    />
                    <polygon
                        className="cls-115"
                        points="333.93 16.8 224.14 110.35 223.84 110 333.93 16.21 333.93 16.8"
                    />
                    <polygon
                        className="cls-116"
                        points="333.93 17.39 224.43 110.69 224.14 110.35 333.93 16.8 333.93 17.39"
                    />
                    <polygon
                        className="cls-117"
                        points="333.93 17.99 224.72 111.03 224.43 110.69 333.93 17.39 333.93 17.99"
                    />
                    <polygon
                        className="cls-118"
                        points="333.93 18.58 225.01 111.38 224.72 111.03 333.93 17.99 333.93 18.58"
                    />
                    <polygon
                        className="cls-119"
                        points="333.93 19.17 225.31 111.72 225.01 111.38 333.93 18.58 333.93 19.17"
                    />
                    <polygon
                        className="cls-119"
                        points="333.93 19.77 225.6 112.06 225.31 111.72 333.93 19.17 333.93 19.77"
                    />
                    <polygon
                        className="cls-120"
                        points="333.93 20.36 225.89 112.41 225.6 112.06 333.93 19.77 333.93 20.36"
                    />
                    <polygon
                        className="cls-120"
                        points="333.93 20.95 226.19 112.75 225.89 112.41 333.93 20.36 333.93 20.95"
                    />
                    <polygon
                        className="cls-121"
                        points="333.93 21.55 226.48 113.1 226.19 112.75 333.93 20.95 333.93 21.55"
                    />
                    <polygon
                        className="cls-122"
                        points="333.93 22.14 226.77 113.44 226.48 113.1 333.93 21.55 333.93 22.14"
                    />
                    <polygon
                        className="cls-123"
                        points="333.93 22.73 227.06 113.78 226.77 113.44 333.93 22.14 333.93 22.73"
                    />
                    <polygon
                        className="cls-124"
                        points="333.93 23.33 227.36 114.13 227.06 113.78 333.93 22.73 333.93 23.33"
                    />
                    <polygon
                        className="cls-125"
                        points="333.93 23.92 227.65 114.47 227.36 114.13 333.93 23.33 333.93 23.92"
                    />
                    <polygon
                        className="cls-126"
                        points="333.93 24.51 227.94 114.81 227.65 114.47 333.93 23.92 333.93 24.51"
                    />
                    <polygon
                        className="cls-127"
                        points="333.93 25.11 228.23 115.16 227.94 114.81 333.93 24.51 333.93 25.11"
                    />
                    <polygon
                        className="cls-127"
                        points="333.93 25.7 228.53 115.5 228.23 115.16 333.93 25.11 333.93 25.7"
                    />
                    <polygon
                        className="cls-128"
                        points="333.93 26.29 228.82 115.84 228.53 115.5 333.93 25.7 333.93 26.29"
                    />
                    <polygon
                        className="cls-129"
                        points="333.93 26.88 229.11 116.19 228.82 115.84 333.93 26.29 333.93 26.88"
                    />
                    <polygon
                        className="cls-130"
                        points="333.93 27.48 229.41 116.53 229.11 116.19 333.93 26.88 333.93 27.48"
                    />
                    <polygon
                        className="cls-131"
                        points="333.93 28.07 229.7 116.88 229.41 116.53 333.93 27.48 333.93 28.07"
                    />
                    <polygon
                        className="cls-131"
                        points="333.93 28.66 229.99 117.22 229.7 116.88 333.93 28.07 333.93 28.66"
                    />
                    <polygon
                        className="cls-132"
                        points="333.93 29.26 230.28 117.56 229.99 117.22 333.93 28.66 333.93 29.26"
                    />
                    <polygon
                        className="cls-132"
                        points="333.93 29.85 230.58 117.91 230.28 117.56 333.93 29.26 333.93 29.85"
                    />
                    <polygon
                        className="cls-133"
                        points="333.93 30.44 230.87 118.25 230.58 117.91 333.93 29.85 333.93 30.44"
                    />
                    <polygon
                        className="cls-134"
                        points="333.93 31.04 231.28 118.5 231.08 118.5 230.87 118.25 333.93 30.44 333.93 31.04"
                    />
                    <polygon
                        className="cls-134"
                        points="333.93 31.63 231.97 118.5 231.28 118.5 333.93 31.04 333.93 31.63"
                    />
                    <polygon
                        className="cls-135"
                        points="333.93 32.22 232.67 118.5 231.97 118.5 333.93 31.63 333.93 32.22"
                    />
                    <polygon
                        className="cls-136"
                        points="333.93 32.81 233.37 118.5 232.67 118.5 333.93 32.22 333.93 32.81"
                    />
                    <polygon
                        className="cls-137"
                        points="333.93 33.41 234.06 118.5 233.37 118.5 333.93 32.81 333.93 33.41"
                    />
                    <polygon className="cls-137" points="333.93 34 234.76 118.5 234.06 118.5 333.93 33.41 333.93 34" />
                    <polygon
                        className="cls-138"
                        points="333.93 34.59 235.46 118.5 234.76 118.5 333.93 34 333.93 34.59"
                    />
                    <polygon
                        className="cls-139"
                        points="333.93 35.19 236.15 118.5 235.46 118.5 333.93 34.59 333.93 35.19"
                    />
                    <polygon
                        className="cls-139"
                        points="333.93 35.78 236.85 118.5 236.15 118.5 333.93 35.19 333.93 35.78"
                    />
                    <polygon
                        className="cls-140"
                        points="333.93 36.37 237.54 118.5 236.85 118.5 333.93 35.78 333.93 36.37"
                    />
                    <polygon
                        className="cls-140"
                        points="333.93 36.97 238.24 118.5 237.54 118.5 333.93 36.37 333.93 36.97"
                    />
                    <polygon
                        className="cls-141"
                        points="333.93 37.56 238.94 118.5 238.24 118.5 333.93 36.97 333.93 37.56"
                    />
                    <polygon
                        className="cls-142"
                        points="333.93 38.15 239.63 118.5 238.94 118.5 333.93 37.56 333.93 38.15"
                    />
                    <polygon
                        className="cls-143"
                        points="333.93 38.75 240.33 118.5 239.63 118.5 333.93 38.15 333.93 38.75"
                    />
                    <polygon
                        className="cls-144"
                        points="333.93 39.34 241.02 118.5 240.33 118.5 333.93 38.75 333.93 39.34"
                    />
                    <polygon
                        className="cls-145"
                        points="333.93 39.93 241.72 118.5 241.02 118.5 333.93 39.34 333.93 39.93"
                    />
                    <polygon
                        className="cls-146"
                        points="333.93 40.52 242.42 118.5 241.72 118.5 333.93 39.93 333.93 40.52"
                    />
                    <polygon
                        className="cls-147"
                        points="333.93 41.12 243.11 118.5 242.42 118.5 333.93 40.52 333.93 41.12"
                    />
                    <polygon
                        className="cls-148"
                        points="333.93 41.71 243.81 118.5 243.11 118.5 333.93 41.12 333.93 41.71"
                    />
                    <polygon
                        className="cls-149"
                        points="333.93 42.3 244.5 118.5 243.81 118.5 333.93 41.71 333.93 42.3"
                    />
                    <polygon className="cls-150" points="333.93 42.9 245.2 118.5 244.5 118.5 333.93 42.3 333.93 42.9" />
                    <polygon
                        className="cls-151"
                        points="333.93 43.49 245.9 118.5 245.2 118.5 333.93 42.9 333.93 43.49"
                    />
                    <polygon
                        className="cls-152"
                        points="333.93 44.08 246.59 118.5 245.9 118.5 333.93 43.49 333.93 44.08"
                    />
                    <polygon
                        className="cls-152"
                        points="333.93 44.68 247.29 118.5 246.59 118.5 333.93 44.08 333.93 44.68"
                    />
                    <polygon
                        className="cls-153"
                        points="333.93 45.27 247.99 118.5 247.29 118.5 333.93 44.68 333.93 45.27"
                    />
                    <polygon
                        className="cls-153"
                        points="333.93 45.86 248.68 118.5 247.99 118.5 333.93 45.27 333.93 45.86"
                    />
                    <polygon
                        className="cls-154"
                        points="333.93 46.46 249.38 118.5 248.68 118.5 333.93 45.86 333.93 46.46"
                    />
                    <polygon
                        className="cls-154"
                        points="333.93 47.05 250.07 118.5 249.38 118.5 333.93 46.46 333.93 47.05"
                    />
                    <polygon
                        className="cls-155"
                        points="333.93 47.64 250.77 118.5 250.07 118.5 333.93 47.05 333.93 47.64"
                    />
                    <polygon
                        className="cls-156"
                        points="333.93 48.23 251.47 118.5 250.77 118.5 333.93 47.64 333.93 48.23"
                    />
                    <polygon
                        className="cls-156"
                        points="333.93 48.83 252.16 118.5 251.47 118.5 333.93 48.23 333.93 48.83"
                    />
                    <polygon
                        className="cls-157"
                        points="333.93 49.42 252.86 118.5 252.16 118.5 333.93 48.83 333.93 49.42"
                    />
                    <polygon
                        className="cls-157"
                        points="333.93 50.01 253.55 118.5 252.86 118.5 333.93 49.42 333.93 50.01"
                    />
                    <polygon
                        className="cls-158"
                        points="333.93 50.61 254.25 118.5 253.55 118.5 333.93 50.01 333.93 50.61"
                    />
                    <polygon
                        className="cls-159"
                        points="333.93 51.2 254.94 118.5 254.25 118.5 333.93 50.61 333.93 51.2"
                    />
                    <polygon
                        className="cls-160"
                        points="333.93 51.79 255.64 118.5 254.94 118.5 333.93 51.2 333.93 51.79"
                    />
                    <polygon
                        className="cls-161"
                        points="333.93 52.39 256.34 118.5 255.64 118.5 333.93 51.79 333.93 52.39"
                    />
                    <polygon
                        className="cls-162"
                        points="333.93 52.98 257.03 118.5 256.34 118.5 333.93 52.39 333.93 52.98"
                    />
                    <polygon
                        className="cls-162"
                        points="333.93 53.57 257.73 118.5 257.03 118.5 333.93 52.98 333.93 53.57"
                    />
                    <polygon
                        className="cls-163"
                        points="333.93 54.17 258.43 118.5 257.73 118.5 333.93 53.57 333.93 54.17"
                    />
                    <polygon
                        className="cls-163"
                        points="333.93 54.76 259.12 118.5 258.43 118.5 333.93 54.17 333.93 54.76"
                    />
                    <polygon
                        className="cls-164"
                        points="333.93 55.35 259.82 118.5 259.12 118.5 333.93 54.76 333.93 55.35"
                    />
                    <polygon
                        className="cls-164"
                        points="333.93 55.95 260.51 118.5 259.82 118.5 333.93 55.35 333.93 55.95"
                    />
                    <polygon
                        className="cls-165"
                        points="333.93 56.54 261.21 118.5 260.51 118.5 333.93 55.95 333.93 56.54"
                    />
                    <polygon
                        className="cls-166"
                        points="333.93 57.13 261.91 118.5 261.21 118.5 333.93 56.54 333.93 57.13"
                    />
                    <polygon
                        className="cls-166"
                        points="333.93 57.72 262.6 118.5 261.91 118.5 333.93 57.13 333.93 57.72"
                    />
                    <polygon
                        className="cls-167"
                        points="333.93 58.32 263.3 118.5 262.6 118.5 333.93 57.72 333.93 58.32"
                    />
                    <polygon
                        className="cls-168"
                        points="333.93 58.91 263.99 118.5 263.3 118.5 333.93 58.32 333.93 58.91"
                    />
                    <polygon
                        className="cls-169"
                        points="333.93 59.5 264.69 118.5 263.99 118.5 333.93 58.91 333.93 59.5"
                    />
                    <polygon
                        className="cls-170"
                        points="333.93 60.1 265.39 118.5 264.69 118.5 333.93 59.5 333.93 60.1"
                    />
                    <polygon
                        className="cls-171"
                        points="333.93 60.69 266.08 118.5 265.39 118.5 333.93 60.1 333.93 60.69"
                    />
                    <polygon
                        className="cls-171"
                        points="333.93 61.28 266.78 118.5 266.08 118.5 333.93 60.69 333.93 61.28"
                    />
                    <polygon
                        className="cls-172"
                        points="333.93 61.88 267.48 118.5 266.78 118.5 333.93 61.28 333.93 61.88"
                    />
                    <polygon
                        className="cls-172"
                        points="333.93 62.47 268.17 118.5 267.48 118.5 333.93 61.88 333.93 62.47"
                    />
                    <polygon
                        className="cls-173"
                        points="333.93 63.06 268.87 118.5 268.17 118.5 333.93 62.47 333.93 63.06"
                    />
                    <polygon
                        className="cls-173"
                        points="333.93 63.66 269.56 118.5 268.87 118.5 333.93 63.06 333.93 63.66"
                    />
                    <polygon
                        className="cls-173"
                        points="333.93 64.25 270.26 118.5 269.56 118.5 333.93 63.66 333.93 64.25"
                    />
                    <polygon
                        className="cls-174"
                        points="333.93 64.84 270.95 118.5 270.26 118.5 333.93 64.25 333.93 64.84"
                    />
                    <polygon
                        className="cls-174"
                        points="333.93 65.43 271.65 118.5 270.95 118.5 333.93 64.84 333.93 65.43"
                    />
                    <polygon
                        className="cls-175"
                        points="333.93 66.03 272.35 118.5 271.65 118.5 333.93 65.43 333.93 66.03"
                    />
                    <polygon
                        className="cls-175"
                        points="333.93 66.62 273.04 118.5 272.35 118.5 333.93 66.03 333.93 66.62"
                    />
                    <polygon
                        className="cls-176"
                        points="333.93 67.21 273.74 118.5 273.04 118.5 333.93 66.62 333.93 67.21"
                    />
                    <polygon
                        className="cls-177"
                        points="333.93 67.81 274.44 118.5 273.74 118.5 333.93 67.21 333.93 67.81"
                    />
                    <polygon
                        className="cls-178"
                        points="333.93 68.4 275.13 118.5 274.44 118.5 333.93 67.81 333.93 68.4"
                    />
                    <polygon
                        className="cls-179"
                        points="333.93 68.99 275.83 118.5 275.13 118.5 333.93 68.4 333.93 68.99"
                    />
                    <polygon
                        className="cls-179"
                        points="333.93 69.59 276.52 118.5 275.83 118.5 333.93 68.99 333.93 69.59"
                    />
                    <polygon
                        className="cls-180"
                        points="333.93 70.18 277.22 118.5 276.52 118.5 333.93 69.59 333.93 70.18"
                    />
                    <polygon
                        className="cls-180"
                        points="333.93 70.77 277.92 118.5 277.22 118.5 333.93 70.18 333.93 70.77"
                    />
                    <polygon
                        className="cls-181"
                        points="333.93 71.36 278.61 118.5 277.92 118.5 333.93 70.77 333.93 71.36"
                    />
                    <polygon
                        className="cls-182"
                        points="333.93 71.96 279.31 118.5 278.61 118.5 333.93 71.36 333.93 71.96"
                    />
                    <polygon
                        className="cls-183"
                        points="333.93 72.55 280 118.5 279.31 118.5 333.93 71.96 333.93 72.55"
                    />
                    <polygon
                        className="cls-184"
                        points="333.93 73.14 280.7 118.5 280 118.5 333.93 72.55 333.93 73.14"
                    />
                    <polygon
                        className="cls-185"
                        points="333.93 73.74 281.4 118.5 280.7 118.5 333.93 73.14 333.93 73.74"
                    />
                    <polygon
                        className="cls-185"
                        points="333.93 74.33 282.09 118.5 281.4 118.5 333.93 73.74 333.93 74.33"
                    />
                    <polygon
                        className="cls-186"
                        points="333.93 74.92 282.79 118.5 282.09 118.5 333.93 74.33 333.93 74.92"
                    />
                    <polygon
                        className="cls-187"
                        points="333.93 75.52 283.48 118.5 282.79 118.5 333.93 74.92 333.93 75.52"
                    />
                    <polygon
                        className="cls-188"
                        points="333.93 76.11 284.18 118.5 283.48 118.5 333.93 75.52 333.93 76.11"
                    />
                    <polygon
                        className="cls-189"
                        points="333.93 76.7 284.88 118.5 284.18 118.5 333.93 76.11 333.93 76.7"
                    />
                    <polygon
                        className="cls-189"
                        points="333.93 77.3 285.57 118.5 284.88 118.5 333.93 76.7 333.93 77.3"
                    />
                    <polygon
                        className="cls-190"
                        points="333.93 77.89 286.27 118.5 285.57 118.5 333.93 77.3 333.93 77.89"
                    />
                    <polygon
                        className="cls-191"
                        points="333.93 78.48 286.96 118.5 286.27 118.5 333.93 77.89 333.93 78.48"
                    />
                    <polygon
                        className="cls-192"
                        points="333.93 79.08 287.66 118.5 286.96 118.5 333.93 78.48 333.93 79.08"
                    />
                    <polygon
                        className="cls-193"
                        points="333.93 79.67 288.36 118.5 287.66 118.5 333.93 79.08 333.93 79.67"
                    />
                    <polygon
                        className="cls-193"
                        points="333.93 80.26 289.05 118.5 288.36 118.5 333.93 79.67 333.93 80.26"
                    />
                    <polygon
                        className="cls-194"
                        points="333.93 80.85 289.75 118.5 289.05 118.5 333.93 80.26 333.93 80.85"
                    />
                    <polygon
                        className="cls-195"
                        points="333.93 81.45 290.44 118.5 289.75 118.5 333.93 80.85 333.93 81.45"
                    />
                    <polygon
                        className="cls-196"
                        points="333.93 82.04 291.14 118.5 290.44 118.5 333.93 81.45 333.93 82.04"
                    />
                    <polygon
                        className="cls-197"
                        points="333.93 82.63 291.84 118.5 291.14 118.5 333.93 82.04 333.93 82.63"
                    />
                    <polygon
                        className="cls-198"
                        points="333.93 83.23 292.53 118.5 291.84 118.5 333.93 82.63 333.93 83.23"
                    />
                    <polygon
                        className="cls-199"
                        points="333.93 83.82 293.23 118.5 292.53 118.5 333.93 83.23 333.93 83.82"
                    />
                    <polygon className="cls-199" points="293.23 118.5 333.93 83.82 333.93 118.5 293.23 118.5" />
                </g>
                <path
                    className="cls-200"
                    d="M11,60.23c.71,5.86,6.57,9.7,14.33,9.7s13-3.79,13-9.08c0-4.59-3.26-7.23-11.28-9.13l-8.25-1.94C7.1,47.09,1.54,41.45,1.54,32.37c0-11.29,9.83-18.91,23.68-18.91,14,0,23.27,7.58,23.54,18.78H37.91c-.53-6-5.51-9.52-12.78-9.52s-12,3.52-12,8.81c0,4.23,3.22,6.7,11,8.55l7.32,1.68c12.92,3,18.38,8.29,18.38,17.77,0,12.07-9.69,19.66-25.08,19.66C10.1,79.19.48,72,0,60.23Z"
                />
                <path
                    className="cls-200"
                    d="M55.42,64.77c0-8.29,6.39-13.27,17.77-14l12.34-.71V46.74c0-4.89-3.31-7.71-8.73-7.71-5.2,0-8.51,2.51-9.21,6.39H57.4c.49-8.73,7.94-15,19.84-15,11.59,0,19.13,6.13,19.13,15.52V78.13H85.79V70.68h-.22C82.88,75.75,77,78.88,71,78.88,62,78.88,55.42,73.19,55.42,64.77Zm30.11-4V57.23l-10.8.66c-5.29.36-8.33,2.74-8.33,6.44s3.17,6.26,7.93,6.26C80.55,70.59,85.53,66.45,85.53,60.8Z"
                />
                <path
                    className="cls-200"
                    d="M105.5,14.52h10.85v24.9h.22c2.51-5.68,7.67-8.9,14.77-8.9,10.31,0,16.35,6.79,16.35,17.5V78.13h-11V50.27c0-6.53-3.27-10.45-9.62-10.45-6.61,0-10.62,4.59-10.62,11.46V78.13h-11Z"
                />
                <path
                    className="cls-200"
                    d="M154.62,64.77c0-8.29,6.39-13.27,17.77-14l12.34-.71V46.74c0-4.89-3.31-7.71-8.73-7.71-5.2,0-8.51,2.51-9.21,6.39H156.6c.49-8.73,7.94-15,19.84-15,11.59,0,19.13,6.13,19.13,15.52V78.13H185V70.68h-.22c-2.69,5.07-8.55,8.2-14.54,8.2C161.19,78.88,154.62,73.19,154.62,64.77Zm30.11-4V57.23l-10.8.66c-5.29.36-8.33,2.74-8.33,6.44s3.17,6.26,7.93,6.26C179.75,70.59,184.73,66.45,184.73,60.8Z"
                />
                <path
                    className="cls-201"
                    d="M271.62,62.2h-23.4l-5.43,16.45H231.07L253.64,15h12.83L289,78.65h-12Zm-20.76-8.77h18.08l-8.87-27.15h-.3Z"
                />
                <path className="cls-201" d="M295.83,78.65V15h11.38V78.65Z" />
            </g>
        </g>
    </svg>
);
export default Icon;
